import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component ReminderIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <ReminderIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <ReminderIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ReminderIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      data-testid="ReminderIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path d="M13.95 13.95h-3v-1.125h1.875V10.95h1.125z" />
      <path
        fillRule="evenodd"
        d="M13.2 8.7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 1.125a3.376 3.376 0 1 0 0 6.75 3.376 3.376 0 0 0 0-6.75"
        clipRule="evenodd"
      />
      <path d="M6 3h6V1.5h1.5V3H15a1.5 1.5 0 0 1 1.5 1.5v3H15V6H3v9h4.5v1.5H3A1.5 1.5 0 0 1 1.5 15V4.5A1.5 1.5 0 0 1 3 3h1.5V1.5H6z" />
      <path d="M6.75 9.75H4.5V7.5h2.25z" />
    </svg>
  )
);
ReminderIcon.displayName = "ReminderIcon";
export default ReminderIcon;
